import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
// import { Buffer } from 'buffer';
import { Box, Button, Checkbox, Container, FormControl, FormControlLabel,FormHelperText,InputLabel,MenuItem,ModalManager,Select,Stack,TextField, Typography } from '@mui/material';
import NestedModal from './NestedModal';
const checkboxOptions = [
  {value: 'Archaeology_International', label: 'Archaeology International'},
  {value: 'Architecture_MPS', label: 'Architecture_MPS'},
  {value: 'Europe and the World: A law review', label: 'Europe and the World: A law review'},
  {value: 'Film Education Journal', label: 'Film Education Journal'},
  {value: 'History Education Research Journal', label: 'History Education Research Journal'},
  {value: 'International Journal of Development Education and Global Learning', label: 'International Journal of Development Education and Global Learning'},
  {value: 'International Journal of Social Pedagogy', label: 'International Journal of Social Pedagogy'},
  // {value: 'Journal of Bentham Studies', label: 'Journal of Bentham Studies'},
  {value: 'London Review of Education', label: 'London Review of Education'},
  {value: 'Radical Americas', label: 'Radical Americas'},
  {value: 'Research for All', label: 'Research for All'},
  {value: 'The Journal of the Sylvia Townsend Warner Society', label: 'The Journal of the Sylvia Townsend Warner Society'},
  {value: 'The London Journal of Canadian Studies',label: 'The London Journal of Canadian Studies'},
   {value: 'UCL Open Environment', label: 'UCL Open Environment' }

];
const jobs =[
  {value: '', label: '---'},
  {value: 'Student / Graduate student', label: 'Student / Graduate student'},
  {value: 'Post-doctoral researcher', label: 'Post-doctoral researcher'},
  {value: 'Early career researcher', label: 'Early career researcher'},
  {value: 'University lecturer or researcher', label: 'University lecturer or researcher'},
  {value: 'Research or laboratory scientist', label: 'Research or laboratory scientist'},
  {value: 'Senior scientist or Principle Investigator', label: 'Senior scientist or Principle Investigator'},
  {value: 'Institution, Department, or Faculty head', label: 'Institution, Department, or Faculty head'},
  {value: 'Technician or Assistant', label: 'Technician or Assistant'},
  {value: 'Manager', label: 'Manager'},
  {value: 'Product manager', label: 'Product manager'},
  {value: 'Director', label: 'Director'},
  {value: 'Publisher, Editor, Writer', label: 'Publisher, Editor, Writer'},
  {value: 'Librarian', label: 'Librarian'},
  {value: 'Public', label: 'Public'},
  {value: 'Other', label: 'Other'},
];
const jobValues = jobs.map(job => job.value);
const workplaces=[
  {value: '', label: '---'},
  {value: 'Academic', label: 'Academic'},
  {value: 'Commercial / Industry', label: 'Commercial / Industry'},
  {value: 'Government', label: 'Government'},
  {value: 'Charity / NGO', label: 'Charity / NGO'},
  {value: 'Private company', label: 'Private company'},
  {value: 'Public', label: 'Public'},
  {value: 'Other', label: 'Other'}
]
const workplaceValues = workplaces.map(workplace => workplace.value);
const validationSchema = Yup.object({
  first_name: Yup.string().required('First name required'),

  last_name: Yup.string().required('Last name required'),

  email: Yup.string().required('Email required'),

  job_type: Yup.mixed().oneOf(
    jobValues, // options array
    'Job type required'
  ).required('Job type required'),

  workplace: Yup.mixed().oneOf(
    workplaceValues, // options array
    'Workplace required'
  ).required('Workplace required'),

  journals: Yup.array().min(1, 'Select at least one journal'),
  terms: Yup.bool().oneOf([true], 'Terms must be accepted')

})
// ...rest of imports and config

export default function SignupForm() {
  const [open,setOpen] = React.useState(false)
  const [loading,setLoading] = React.useState(false)
  const [success,setSuccess] = React.useState(false)
  const handleSubmit = async (values,{resetForm}) => {
    setLoading(true)
    setOpen(true)
    const { first_name,last_name, email,job_type,workplace,journals,terms } = values;
    // Get checked journals
    const checkedJournals = journals;

    // const dataPack = {
    //   first_name,
    //   last_name,
    //   email,
    //   job_type,
    //   workplace,
    //   checkedJournals,
    //   terms,

    // }
   // console.log("dataPack",dataPack)

  axios.post(
    `https://europe-west2-ucl-journals.cloudfunctions.net/getSubscriber`,{email_address: email}
  ).then((response) => {
    console.log(response);
    const postData ={
      email_address: email,
      first_name: first_name,
      last_name: last_name,
      job_type: job_type,
      workplace: workplace,
      journals: checkedJournals,
      terms: terms
    }
    if(response.statusCode=='404'){
      axios.post(
        `https://europe-west2-ucl-journals.cloudfunctions.net/addSubscriber`,postData
      ).then((response) => {
        setSuccess(true)
        resetForm();
        setLoading(false)
      }).catch((error) => {
        setSuccess(false)
        setLoading(false)
      });

    }else{
      axios.put(
        `https://europe-west2-ucl-journals.cloudfunctions.net/updateSubscriber`,postData
      ).then((response) => {
        console.log(response);
        setSuccess(true)
        resetForm();
        setLoading(false)
      }).catch((error) => {
        console.log(error);
        setSuccess(false)
        setLoading(false)
      });

    }
  }).catch((error) => {
    console.log(error);
    setSuccess(false)
       setLoading(false)
  });



  // const axiosInstance = axios.create({
  //   baseURL: apiUrl,
  //   headers: {
  //     Authorization: `Basic ${Buffer.from(`anystring:${apiKey}`).toString('base64')}`,
  //   }
  // });

  // axiosInstance.get()
  //   .then(response => {
  //     if (!response.ok) {
  //       throw new Error("Network response was not ok");
  //     }
  //     return response.json();
  //   })
  //   .then(data => {
  //     // Handle the response data here
  //     console.log("mailchim data",data);
  //   })
  //   .catch(error => {
  //     // Handle errors here
  //     console.error("Error:", error);
  //   });


    // Check if email exists in Mailchimp
    //const memberExists = await mailchimp.checkMemberExists(email);

   // if (memberExists) {
      // Update member with checkboxes as tags
    //  await mailchimp.updateMemberTags(email, checkboxes);
   // } else {
      // Subscribe new member with tags
    //  await mailchimp.subscribeMember(name, email, checkboxes);
   // }
  }
  const initialValues={
    first_name: '',
    last_name: '',
    email: '',
    job_type: '',
    workplace: '',
    journals: [], // array of checked values
    terms:false
  }
  // const initialValues={
  //   first_name: 'Matt',
  //   last_name: 'Crane',
  //   email: 'matt@dzined.com',
  //   job_type: 'Research or laboratory scientist',
  //   workplace: 'Academic',
  //   journals: ["Archaeology International"], // array of checked values
  //   terms:true
  // }

  // const [ setChecked] = React.useState(false);

  // const handleTerms = (event) => {
  //   setChecked(event.target.checked);
  // };
  return (
    <React.Fragment>
      <NestedModal open={open} setOpen={setOpen} loading={loading} success={success} />
          <Box sx={{background:'#AA0000',p:3,height:15}}>
    {/* <Typography sx={{textAlign:'center',fontSize:30,color:'#FFF'}}>Sign up to our Publishing Alerts</Typography> */}
        </Box>
    <Stack direction="row" alignItems={"flex-start"} justifyContent={"center"} sx={{background:'#EDEDED',minHeight:'100vh'}}>

    <Container maxWidth="sm">
      <Stack sx={{background:'#FFF',p:4}} alignItems="center" justifyContent={"flex-start"}>
        <Box component="img" sx={{width:'100%',textAlign:'center',maxWidth:300,mb:2}} src="/ucllogo.jpg" alt="UCL Press" />
        <Typography variant="body1" gutterBottom sx={{marginBottom:2}}>
        If you would you like to sign up to receive news, updates and calls for papers from UCL Press Journals, please complete the form below. You can select the Journal(s) that you would like to hear about below.
          </Typography>
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnChange={true} // only validate on submit
  validateOnBlur={true}
    >



      {({ values, errors, handleChange, handleSubmit  }) => (
        <form onSubmit={handleSubmit}>

          <Stack direction="column" spacing={2}>
          <Stack direction={{xs:'column',sm:'row'}} spacing={2} sx={{width:'100%'}}>
            <FormControl sx={{flex:1}} >
            <TextField
              name="first_name"
              value={values.first_name}
              onChange={handleChange}
              label="First Name"
              variant="outlined"
              error={!!errors.first_name}
              helperText={errors.first_name}
            />

          </FormControl>
          <FormControl sx={{flex:1}}>
            <TextField
              name="last_name"
              value={values.last_name}
              onChange={handleChange}
              label="Last Name"
              variant="outlined"
              error={!!errors.last_name}
              helperText={errors.last_name}
            />
          </FormControl>
          </Stack>
          <FormControl>
          <InputLabel>Job Type</InputLabel>
          <Select
  error={!!errors.job_type}
  value={values.job_type}
  onChange={handleChange}
  name="job_type"
  label="Job Type">
  {jobs.map(option => (
    <MenuItem key={option.value} value={option.value}>
      {option.label}
    </MenuItem>
  ))}
</Select>
    </FormControl>
    <FormControl>
          <InputLabel>Workplaces</InputLabel>
          <Select
  error={!!errors.workplace}
  value={values.workplace}
  onChange={handleChange}
  name="workplace"
  label="Workplace">
  {workplaces.map(option => (
    <MenuItem key={option.value} value={option.value}>
      {option.label}
    </MenuItem>
  ))}
</Select>
    </FormControl>
          <FormControl>
            <TextField
              name="email"
              value={values.email}
              onChange={handleChange}
              label="Email"
              error={!!errors.email}
              helperText={errors.email}
              placeholder='Enter your email'
              variant="outlined"
            />

          </FormControl>
              <Typography sx={{fontWeight:'bold',pt:4}}>Choose one or more journals</Typography>
          <FormControl>

          <FormHelperText error>{errors.journals}</FormHelperText>
          {checkboxOptions.map(option => (
              <FormControlLabel

              name="journals"
              disableTypography
              sx={{fontSize:14}}
                key={option.value}
                control={<Checkbox
                  checked={values.journals.includes(option.value)}
        onChange={handleChange}
        value={option.value}

                  />}
                label={option.label}
              />
            ))}
          </FormControl>

<Box>
<Typography variant="h4" sx={{fontSize:16,fontWeight:'bold',mb:2}}>Legal Permissions</Typography>
<Typography variant="body1" gutterBottom sx={{fontSize:14,fontWeight:'normal'}}>UCL Press Journals will use the information you provide on this form to be in touch with you and to provide updates on the journals you have selected, their publications, news and calls for contributions. Please tick the box below to confirm that you would like to hear from us:</Typography>

<FormControlLabel
  disableTypography
  name="terms"
  sx={{
    fontSize: 14,
  }}
  control={
    <Checkbox
      checked={values.terms}
      onChange={handleChange}
    />
  }
  label="I would like to hear from the UCL Press Journals by email"
/>
        <FormHelperText error>{errors.terms}</FormHelperText>



<Typography variant="body1" gutterBottom sx={{fontSize:14,fontWeight:'normal'}}>You can change your mind at any time by clicking the unsubscribe link in the footer of any email you receive from us or by contacting us at <a href="mailto:uclpressjournals@ucl.ac.uk" style={{color:'#AA0000'}}>uclpressjournals@ucl.ac.uk</a>. We will treat your information with respect. For more information about our privacy practices please visit our <a style={{color:'#AA0000'}} href="https://www.uclpress.co.uk/pages/privacy-policy">website</a>. By clicking below, you agree that we may process your information in accordance with these terms.</Typography>

<Typography variant="body1" gutterBottom sx={{fontSize:14,fontWeight:'normal'}}>By clicking below to subscribe, you acknowledge that your information will be transferred to Mailchimp for processing. <a style={{color:'#AA0000'}} href="https://mailchimp.com/legal/terms">Learn more about Mailchimp's privacy practices here</a>.</Typography>


</Box>

          <Stack direction="row" justifyContent={"flex-end"}>
          <Button style={{backgroundColor:'#AA0000'}} variant="contained" type="submit" fullWidth>
            Submit
          </Button>

          </Stack>
          </Stack>


        </form>
      )}
    </Formik>
    </Stack>
    </Container></Stack>
    </React.Fragment>
  );
}